import { Colors } from 'styles';
import { type AddendumFieldsFragment } from 'generated/graphql';
import { Renderer } from '../../RichTextEditor';
import { formatAddendumContentByType } from './utils';
import Divider from '@mui/material/Divider';
import { CustomElement } from 'domains/reporter/RichTextEditor/slate-custom-types';
import { ReportSignedByLabel } from 'domains/reporter/RichTextEditor/ui/ReportSignedByLabel';

export const renderAddendums = (
  addendums: ReadonlyArray<AddendumFieldsFragment>
): React.ReactElement[] => {
  const sentAddendums = addendums.filter((addendum) => !!addendum.sentAt);

  if (sentAddendums.length === 0) {
    return [];
  }

  return sentAddendums.map((addendum, idx) => {
    return (
      <div key={addendum.smid}>
        <Divider
          css={`
            background-color: ${Colors.gray6};
            margin: 1em 0;
          `}
        />
        {addendum.submittedAt && (
          <div style={{ marginLeft: '-4px', marginBottom: '8px' }}>
            <ReportSignedByLabel
              firstName={addendum.owner?.firstName}
              lastName={addendum.owner?.lastName}
              submittedAt={addendum.submittedAt}
            />
          </div>
        )}
        <strong>Addendum #{idx + 1}</strong>
        {(formatAddendumContentByType(addendum.content) as CustomElement[]).map(
          (content, contentIdx) => {
            return (
              <Renderer
                key={`${addendum.smid}-${contentIdx}`}
                content={[content]}
                isReadOnly={true}
              />
            );
          }
        ) ?? []}
      </div>
    );
  });
};
